import { Link } from "react-router-dom";
import { Facebook, Mail } from "lucide-react";
import Logo from "@/components/Logo";

const FACEBOOK_URL = "https://www.facebook.com/people/The-Mahogany-Room-A-Literary-Society-for-Black-Women/61593363442767/";

export const Footer = () => (
  <footer className="relative bg-mahogany-950 border-t border-gold/20 pt-20 pb-10 overflow-hidden grain" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid md:grid-cols-4 gap-12 mb-16">
        <div className="md:col-span-1">
          <Logo size="md" withTagline />
        </div>
        <div>
          <h4 className="overline mb-5">Explore</h4>
          <ul className="space-y-3 text-cream/70 text-sm">
            <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
            <li><Link to="/how-it-works" className="hover:text-gold transition-colors">How It Works</Link></li>
            <li><Link to="/books" className="hover:text-gold transition-colors">Our Books</Link></li>
            <li><Link to="/events" className="hover:text-gold transition-colors">Meetups & Events</Link></li>
            <li><Link to="/community" className="hover:text-gold transition-colors">The Community</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-5">Connect</h4>
          <ul className="space-y-3 text-cream/70 text-sm">
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
            <li><a href="mailto:jabrena@joinmahogany.com" className="hover:text-gold transition-colors">jabrena@joinmahogany.com</a></li>
            <li><Link to="/join" className="hover:text-gold transition-colors">Join The Room</Link></li>
            <li><Link to="/privacy" className="hover:text-gold transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-gold transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-5">Follow Along</h4>
          <div className="flex gap-3 mb-6">
            {[{ Icon: Facebook, label: "facebook", href: FACEBOOK_URL }, { Icon: Mail, label: "email", href: "mailto:jabrena@joinmahogany.com" }].map(({ Icon, label, href }) => (
              <a key={label} href={href} target={label === "facebook" ? "_blank" : undefined} rel={label === "facebook" ? "noreferrer" : undefined} data-testid={`social-${label}`} className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-mahogany-900 transition-colors">
                <Icon size={16} strokeWidth={1.5} />
              </a>
            ))}
          </div>
          <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" data-testid="footer-facebook-community" className="inline-flex items-center gap-2 text-sm text-fuchsia hover:text-fuchsia-dark transition-colors">
            <Facebook size={16} /> Join our private Facebook community
          </a>
        </div>
      </div>

      <div className="text-center py-10 border-t border-gold/10">
        <p className="font-script text-3xl sm:text-4xl text-gold mb-2">Enter the Room. Change Your Chapter.</p>
        <p className="text-cream/50 text-sm uppercase tracking-[0.2em]">Good Books. Dope Women. Real Conversations.</p>
      </div>

      <div className="text-center text-cream/40 text-xs pt-6">
        © {new Date().getFullYear()} The Mahogany Room · A Literary Society for Black Women · By Jabrena
      </div>
    </div>
  </footer>
);

export default Footer;
